import axios from "axios";
import API_BASE_URL from '../../config';

export const SetProgressUserTaskService = async (token, userId, taskId, progressTask, lastView, starts) => {
  try {
    if (!token) {
      throw new Error("No token available");
    }

    const response = await axios.post(`${API_BASE_URL}api/set-progress-user-task/`,
      {
        user_id: userId,
        task_id: taskId,
        progress_task: progressTask,
        last_view: lastView,
        starts: starts
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error('Error al actualizar progreso de la tarea:', error.response ? error.response.data : error.message);
    throw error;
  }
};
